/**
 * Class initializing Cookie Layer.
 */
// TODO Refactor CookielascheInterface => CookieLayerWrapper
class CookielascheInterface {
	/**
	 * @see {@link CookielascheInterface#init}
	 */
	constructor () {
		this.init();
	}

	/**
	 * Initializes Cookie Layer for usage on page.
	 * @listens Document#pageReady
	 */
	init () {
		const setOptinAndUpdateModel = () => {
			window.PermissionClientCompat.setConsentLevel('2');
			window.PermissionClientCompat.updateModelByConsentLevel();

			document.removeEventListener('click', setOptinAndUpdateModel);
		};

		let brand = window.SiteInfo.brand.toLowerCase();
		let tld = window.SiteInfo.tld.toLowerCase();
		brand = brand === 'gmx' && tld !== 'net' ? brand + tld : brand;
		brand = brand === 'einsundeins' ? '1und1' : brand;

		const config = {
			portal: brand,
			category: 'homepage',
			forcePermissionLayer: 'tcf_v2',
			consentParameters: {
				tcfLayerMode: brand === '1und1' ? 'slim' : undefined
			},
			onChange: (model) => {
				const computedConsentLevel = window.PermissionClientCompat.computeConsentLevelByModel(model);
				window.PermissionClientCompat.setConsentLevel(computedConsentLevel);
				window.PermissionClient.DEFAULT_HANDLER.onChange(model);
			},
			getModel: function () {
				// permission model stored on localStorage
				const permModel = window.PermissionClient.DEFAULT_HANDLER.getModel();

				// sync Permission model with consentLevel
				// consentLevel is leading here
				const model = window.PermissionClientCompat.computeModelByConsentLevel(permModel);

				return model;
			},
			onShowLayer: () => {
				if (!config.consentParameters.tcfLayerMode) {
					document.body.setAttribute('data-no-scroll', '');
				}

				let event = new CustomEvent('pppLayerVisible', { bubbles: true, cancelable: true, detail: { source: 'cookielascheInterface.js' } });
				document.dispatchEvent(event);
			},
			onComplete: () => {
				document.body.removeAttribute('data-no-scroll');
				document.removeEventListener('click', setOptinAndUpdateModel);
				window.PermissionClient.DEFAULT_HANDLER.onComplete();

				let event = new CustomEvent('pppLayerClosed', { bubbles: true, cancelable: true, detail: { source: 'cookielascheInterface.js' } });
				document.dispatchEvent(event);
			}
		};

		const permissionClientCompatReady = new Promise((resolve, reject) => {
			(function waitForIt () {
				if (window.PermissionClientCompat) return resolve();
				setTimeout(waitForIt, 30);
			})();
		});

		permissionClientCompatReady.then(
			() => {
				try {
					window.PermissionClientCompat.init(window.PermissionClient, {
						cookieDomain: window.SiteInfo.brandShort + '.' + window.SiteInfo.tld
					});
					window.PermissionClient.init(config);
					window.PermissionClientCompat.updateModelByConsentLevel();

					if (!window.PermissionClientCompat.getConsentLevel()) {
						document.addEventListener('click', setOptinAndUpdateModel);
					}
				} catch (e) {
					document.body.removeAttribute('data-no-scroll');
				}
			},
			(error) => {
				console.log(error); // we dont have permissionClientCompat... but should never happen
			}
		);
	}
}

export { CookielascheInterface };
